export enum MarketSegmentModel
{
    HR = 0,
    Events = 1,
    Teacher = 2
}
